import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { InstagramReelPostSortField } from '@anytag/graphql';

export const InfluencerInstagramReelPostsListSearchSchema = SearchSchema.create({
  sort: { field: InstagramReelPostSortField },
  filter: {
    schema: z.object({
      name: SearchSchema.types.string(),
      keyword: SearchSchema.types.string()
    })
  }
});

export type InfluencerInstagramReelPostsListSearchType = z.infer<typeof InfluencerInstagramReelPostsListSearchSchema>;
